var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9231 1.12119C19.7905 1.35471 20.4744 2.03861 20.7079 2.90598C21.1416 4.49061 21.1249 7.79332 21.1249 7.79332C21.1249 7.79332 21.1249 11.0793 20.7079 12.664C20.4744 13.5314 19.7905 14.2152 18.9231 14.4488C17.3385 14.8658 11 14.8658 11 14.8658C11 14.8658 4.67811 14.8658 3.0768 14.4321C2.20943 14.1986 1.52553 13.5147 1.29201 12.6473C0.875 11.0793 0.875 7.77664 0.875 7.77664C0.875 7.77664 0.875 4.49061 1.29201 2.90598C1.52553 2.03861 2.22611 1.33803 3.0768 1.10451C4.66143 0.6875 11 0.6875 11 0.6875C11 0.6875 17.3385 0.6875 18.9231 1.12119ZM14.2526 7.66082L8.98162 10.6966V4.625L14.2526 7.66082Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.567c65af58d4b360530698ea7cf742fd.svg";
export { ForwardRef as ReactComponent };